<template>
  <b-button-group vertical
                  v-if="isVisible"
                  size="sm"
                  :class="'us_overlay us_zoomControl'">
    <b-button @click="zoomFit"
              class="zoom-button"
              :class="{ 'is-selected': selectedMag === 'fit' }"
              size="sm"
              :title="$t('uScope.extensions.zoom.fit')">
      <icon name="compress"/>
    </b-button>
    <zoom-button v-for="mag in mags"
                 :key="mag"
                 :mag="mag"
                 :base-mag="baseMag"
                 :is-selected="mag === selectedMag"
                 :is-pyramid-level="!!pyramid.find(p => p.realMag === mag)"
                 @click="changeZoom(mag)"
    />
  </b-button-group>
</template>

<script>
  import Icon from 'vue-awesome/components/Icon';
  import 'vue-awesome/icons/compress';
  import last from 'lodash/last';
  import { renderSettings } from '../../render-settings';
  import ZoomButton from './ZoomButton';
  import us from '../../defines';
  import { translate } from '../../../../shared/services/I18nService';
  import { makeVisibilityHelper } from '../viewport-overlay';

  export default {
    name: 'ZoomButtonList',
    components: { ZoomButton, Icon },
    inject: ['viewport', 'dependencies'],
    data () {
      return {
        selectedMag: 0,
        baseMag: this.viewport.xinfo.get_baseMag(), // "real" vs the mangled one
        maxMag: this.viewport.getMaximumMag(),
        pyramid: this.viewport.getPyramid(),
        isVisible: false
      };
    },
    computed: {
      mags () {
        // Collect the list of allowed mags.
        const mags = renderSettings.magnificationList.filter((mag) => mag <= this.baseMag);

        // Ensure the base mag is in the list (some images are scanned at oddball mags like 63x)
        if (!mags.includes(this.baseMag)) {
          mags.push(this.baseMag);
        }

        // Add digital zooms to fill in the gap between basemag and max mag (for hidpi monitors)
        let multiplier = 2;
        while (last(mags) < this.maxMag) {
          mags.push(this.baseMag * multiplier);
          multiplier++;
        }

        // Add pyramid levels, if configured to (not user-facing; used for IQ assessments only. See rendersettings for more info)
        if (renderSettings.showAllPyramidLevelsInZoomControl) {
          this.pyramid.forEach(level => {
            const levelMag = level.realMag;
            if (!mags.find((mag) => mag === levelMag)) {
              const sibling = mags.find((mag) => mag > levelMag);
              mags.splice(sibling ? mags.indexOf(sibling) : mags.length, 0, levelMag);
            }
          });
        }
        return mags;
      }
    },
    methods: {
      updateVisibility (isVisible) {
        this.isVisible = isVisible;
        this.$nextTick(() => this.viewport.overLayout.refreshPrecinct('BL'));
      },
      zoomFit () {
        this.viewport.zoomAbsolute('Fit');
      },
      changeZoom (mag) {
        if (mag === this.viewport.getViewMag()) {
          // don't bother changing zoom if we're already here
          return;
        }

        const zoom = this.viewport.convertToZoom(mag);
        this.viewport.zoomAbsolute(zoom);
      },
      updateSelectedMag () {
        if (this.viewport.isFitZoom()) {
          this.selectedMag = 'fit';
        } else {
          this.selectedMag = this.viewport.getViewMag();
        }
      }
    },
    mounted () {
      this.viewport.renderer.addLayer({
        zoomChange: this.updateSelectedMag
      });
      const [userConfig, visibilityPanel] = this.dependencies;
      visibilityPanel.addOption({
        key: us.clsDIVZOOMCTL,
        label: translate('uScope.extensions.settings-service.visibility-panel.zoom-control')
      }, 1);
      makeVisibilityHelper(userConfig, us.clsDIVZOOMCTL, this.viewport)
        .onVisibilityChanged(this.updateVisibility);
    }
  };
</script>

<style scoped lang="scss">
@import '~lbs-pi-web-styles/lib/variables';
@import './zoom-button';

.btn-group-vertical { // added because..?
  display: flex;
  flex-direction: column;
}
</style>
